import React from 'react';
import HomeHeader from 'src/shared/components/HomeHeader';
import styles from './Header.module.scss';

export const Header = () => {
  return <HomeHeader classes={{ root: styles.root }} bgColor="transparent" />;
};
